<syn-avatar
    matIco="domain"
    [size]="size"
    [tooltip]="tooltip ? title : ''"
    [link]="clickable ? link : undefined"
    [text]="text"
    [backgroundColor]="backgroundColor"
    [iconColor]="iconColor"
    [caption]="caption"
></syn-avatar>
